import DashboardTypeEnum from "../models/DashboardTypeEnum";
import IDashboard from "../models/IDashboard";
import ISupplierModel from "../models/ISupplierModel";
import IUserUI from "../models/IUserUI";

const getIsDefaultDashboard = (dashboard: IDashboard | undefined, supplierModel: ISupplierModel, userModel: IUserUI): boolean => {
    if (dashboard) {
        if (dashboard.type === DashboardTypeEnum.SUPPLIER) {
            if (supplierModel.default_dashboard_id === dashboard.id) {
                return true;
            }
        } else if (dashboard.type === DashboardTypeEnum.CUSTOMER) {
            if (supplierModel.default_vendors_dashboard_id === dashboard.id) {
                return true;
            }
        } else if (dashboard.type === DashboardTypeEnum.USER) {
            if (userModel.supplierUserToken?.default_user_dashboard_id === dashboard.id) {
                return true;
            }
        }
    }

    return false;
};

const DashboardService = {
    getIsDefaultDashboard,
};

export default DashboardService;
